<!-- ===== HOME STATE ===== -->
<ng-container *ngIf="currentState().type === 'home'">
    <!-- Top bar -->
    <div class="header">
        <div class="header-left">
            <span class="text-18-500 color-8">{{ homeSetup()?.title || ss.t('common_focusTracker') }}</span>
        </div>
        <div class="header-right">
            <app-svg name="more" class="kebab-btn" [matMenuTriggerFor]="homeKebab" role="button"
                [color]="ss.theme().color12"></app-svg>
            <mat-menu yPosition="above" xPosition="before" #homeKebab="matMenu" class="me-menu info-menu ri-mt-2">
                <button mat-menu-item (click)="openFeatureInfo()">
                    <span class="text-14-400 color-8 flex items-center"><app-svg name="info" class="ri-pe-3"
                            [color]="ss.theme().color35"></app-svg>{{ ss.t('common_info') }}</span>
                </button>
                <button mat-menu-item (click)="openEditSetup()" *ngIf="homeSetup()">
                    <span class="text-14-400 color-8 flex items-center"><app-svg name="edit" class="ri-pe-3"
                            [color]="ss.theme().color35"></app-svg>{{ ss.t('actionCommon_editSetup') }}</span>
                </button>
            </mat-menu>
            <app-svg name="comment" class="icon-mirror-rtl" role="button" [color]="ss.theme().color12"
                (click)="openMessage()" width="20px" height="20px"></app-svg>
            <app-svg name="close" class="close-btn" role="button" [color]="ss.theme().color8"
                (click)="router.navigate(['/today'])"></app-svg>
        </div>
    </div>

    <div class="game-home-content">
        <!-- First-time home (Level 1) — mirrors Flutter _buildHome layout -->
        <ng-container *ngIf="isFirstTime()">
            <div class="hero-section">
                <div class="focus-home-body">
                    <!-- "Your Current Level" + "Level 1" (centered) -->
                    <p class="text-12-700 color-7 mb-0 text-center">{{ ss.t('focus_yourCurrentLevel') }}</p>
                    <p class="text-28-800 color-8 mb-0 text-center" style="margin-top: 4px;">
                        {{ ss.t('focus_level', { count: 1 }) }}</p>

                    <div style="height: 24px;"></div>

                    <!-- Challenge Rules heading + numbered rules -->
                    <div class="focus-rules-block">
                        <p class="text-16-400 color-35 mb-0">{{ ss.t('focus_challengeRules') }}</p>
                        <div style="height: 16px;"></div>
                        <div class="focus-rule-item">
                            <div class="focus-rule-number"><span class="text-14-700 color-35">1</span></div>
                            <p class="text-16-700 color-8 mb-0 focus-rule-text">
                                {{ ss.t('focus_challengeRule1') }}</p>
                        </div>
                        <div style="height: 16px;"></div>
                        <div class="focus-rule-item">
                            <div class="focus-rule-number"><span class="text-14-700 color-35">2</span></div>
                            <p class="text-16-700 color-8 mb-0 focus-rule-text">
                                {{ ss.t('focus_challengeRule2') }}</p>
                        </div>
                        <div style="height: 16px;"></div>
                        <div class="focus-rule-item">
                            <div class="focus-rule-number"><span class="text-14-700 color-35">3</span></div>
                            <p class="text-16-700 color-8 mb-0 focus-rule-text">
                                {{ ss.t('focus_challengeRule3') }}</p>
                        </div>
                    </div>

                    <div style="height: 24px;"></div>

                    <!-- Disclaimer box -->
                    <div class="focus-disclaimer-box">
                        <p class="text-10-700 color-11 mb-0">DISCLAIMER</p>
                        <div style="height: 4px;"></div>
                        <p class="text-10-400 color-8 mb-0">{{ ss.t('focus_disclaimer') }}</p>
                    </div>
                </div>
            </div>

            <div class="bottom-section bottom-center">
                <button class="btn-pill btn-pill-primary" (click)="startLevel()">
                    {{ ss.t('focus_crackLevel', { count: 2 }) }}
                </button>
            </div>
        </ng-container>
    </div>
</ng-container>

<!-- ===== COUNTDOWN STATE ===== -->
<ng-container *ngIf="currentState().type === 'countdown'">
    <div class="header">
        <div class="header-left">
            <span class="text-18-500 color-8">{{ ss.t('focus_level', { count: $any(currentState()).level }) }}</span>
        </div>
        <div class="header-right">
            <app-svg name="close" class="close-btn" role="button" [color]="ss.theme().color8"
                (click)="closeGame()"></app-svg>
        </div>
    </div>

    <div class="game-section">
        <div class="game-container game-countdown">
            <div class="game-countdown-inner">
                <!-- Figma: xxxl.bold (48px) in color35 — matches Flutter countdown -->
                <p class="text-48-700 color-35 mb-0 countdown-number">{{ $any(currentState()).countdownValue }}</p>
            </div>
        </div>
    </div>
</ng-container>

<!-- ===== PLAYING STATE ===== -->
<ng-container *ngIf="currentState().type === 'playing'">
    <div class="header">
        <div class="header-left">
            <span class="text-18-500 color-8">{{ ss.t('focus_level', { count: $any(currentState()).level }) }}</span>
        </div>
        <div class="header-right">
            <app-svg name="close" class="close-btn" role="button" [color]="ss.theme().color8"
                (click)="closeGame()"></app-svg>
        </div>
    </div>

    <div class="game-section">
        <div class="game-container game-playing">
            <div class="game-inner">
                <!-- Shape display -->
                <ng-container *ngIf="$any(currentState()).currentShape">
                    <app-focus-shape [shape]="$any(currentState()).currentShape" [size]="96"></app-focus-shape>
                </ng-container>
            </div>

            <!-- Timer text (Figma: 18x18 clock icon in color35 + 8px gap + lg bold timer) -->
            <!-- Matches Flutter: clock icon + timer text, no progress bar. -->
            <div class="game-timer flex items-center justify-center gap-2" style="padding-top: 16px;">
                <app-svg name="focusTimerClock" [color]="ss.theme().color35" width="18" height="18"></app-svg>
                <span class="game-timer-text color-8">{{ remainingDisplay() | secondsToTime }}</span>
            </div>
        </div>
    </div>
</ng-container>

<!-- ===== ANSWER STATE ===== -->
<ng-container *ngIf="currentState().type === 'answer'">
    <div class="header">
        <div class="header-left">
            <span class="text-18-500 color-8">{{ ss.t('focus_level', { count: $any(currentState()).level }) }}</span>
        </div>
        <div class="header-right">
            <app-svg name="close" class="close-btn" role="button" [color]="ss.theme().color8"
                (click)="closeGame()"></app-svg>
        </div>
    </div>

    <div class="game-section">
        <div class="game-answer answer-phase">
            <div class="answer-block">
                <!-- Question: How many [shape] appeared? -->
                <div class="answer-question flex flex-col items-center">
                    <p class="text-16-400 color-8 mb-0 text-center">{{ ss.t('focus_howManyShapeAppeared') }}</p>
                    <div style="height: 16px;"></div>
                    <app-focus-shape [shape]="$any(currentState()).questionShape" [size]="48"></app-focus-shape>
                </div>

                <!-- 4×3 options grid -->
                <div class="answer-options">
                    <div class="answer-option level-1"
                        *ngFor="let option of $any(currentState()).options"
                        [class.selected]="$any(currentState()).selectedAnswer === option"
                        (click)="selectAnswer(option)" role="button">
                        <div class="btn-option">{{ option }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Submit button -->
    <div class="bottom-section bottom-center">
        <button class="btn-pill btn-pill-primary" (click)="submitAnswer()"
            [disabled]="$any(currentState()).selectedAnswer === null">
            {{ ss.t('focus_submit') }}
        </button>
    </div>
</ng-container>

<!-- ===== RESULT STATE ===== -->
<ng-container *ngIf="currentState().type === 'result'">
    <div class="header">
        <div class="header-left">
            <span class="text-18-500 color-8">{{ ss.t('focus_level', { count: $any(currentState()).level }) }}</span>
        </div>
        <div class="header-right">
            <app-svg name="close" class="close-btn" role="button" [color]="ss.theme().color8"
                (click)="goHome()"></app-svg>
        </div>
    </div>

    <div class="game-section game-section-result">
        <!-- Correct answer — celebration illustration + "You're On / Level N" (matches Figma + Flutter) -->
        <ng-container *ngIf="$any(currentState()).isCorrect">
            <div class="flex flex-col items-center">
                <app-svg name="focusTrackerCorrect" style="width: 80px; height: 80px;"></app-svg>
                <div style="height: 16px;"></div>
                <p class="text-12-700 color-35 mb-0 text-center">{{ ss.t('focus_youreOn') }}</p>
                <div style="height: 4px;"></div>
                <p class="text-28-800 color-35 mb-0 text-center">
                    {{ ss.t('focus_level', { count: $any(currentState()).level }) }}</p>
            </div>
        </ng-container>

        <!-- Wrong answer -->
        <ng-container *ngIf="!$any(currentState()).isCorrect">
            <div class="flex flex-col items-center">
                <p class="text-24-700 color-11 mb-0 text-center">{{ ss.t('focus_notQuiteRight') }}</p>
                <div style="height: 16px;"></div>
                <div class="flex items-center gap-4">
                    <div class="flex flex-col items-center">
                        <p class="text-12-400 color-7 mb-0">{{ ss.t('focus_correctAnswer') }}</p>
                        <p class="text-24-700 color-1 mb-0">{{ $any(currentState()).correctCount }}</p>
                    </div>
                    <div class="flex flex-col items-center">
                        <p class="text-12-400 color-7 mb-0">{{ ss.t('focus_yourAnswer') }}</p>
                        <p class="text-24-700 color-11 mb-0">{{ $any(currentState()).userAnswer }}</p>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <!-- Result bottom CTA -->
    <div class="bottom-section bottom-center">
        <!-- Correct: Crack next level or crown for max -->
        <ng-container *ngIf="$any(currentState()).isCorrect">
            <ng-container *ngIf="$any(currentState()).level >= 10">
                <div class="flex flex-col items-center">
                    <app-svg name="focusCrown" [color]="ss.theme().color35"
                        style="width: 48px; height: 48px;"></app-svg>
                    <div style="height: 8px;"></div>
                    <p class="text-14-400 color-7 mb-0 text-center">{{ ss.t('focus_top1Percent') }}</p>
                </div>
            </ng-container>
            <button *ngIf="$any(currentState()).level < 10" class="btn-pill btn-pill-primary"
                (click)="crackNextLevel()">
                {{ ss.t('focus_crackLevel', { count: $any(currentState()).level + 1 }) }}
            </button>
        </ng-container>
        <!-- Incorrect: Try again -->
        <button *ngIf="!$any(currentState()).isCorrect" class="btn-pill btn-pill-primary" (click)="tryAgain()">
            {{ ss.t('focus_tryAgain') }}
        </button>
    </div>
</ng-container>
